import { render, staticRenderFns } from "./Aboutp.vue?vue&type=template&id=01ff56b7&"
import script from "./Aboutp.vue?vue&type=script&lang=js&"
export * from "./Aboutp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports